<script>
    export let icon = 'fad fa-users'
    export let image = null
    export let bgColor = null
    export let fgColor = null
    
    let colorVar = (bgColor ? `--components-primary-bg: ${bgColor};` : '') + (fgColor ? `--components-primary-fg: ${fgColor}` : '')
</script>

<style>
    .BigIcon .icon {
        display: inline-block;
        background-color: var(--components-primary-bg);
        color: var(--components-primary-fg);
        width: 70px;
        height: 70px;
        line-height: 70px;
        font-size: 22px;
        border-radius: 5px;
        text-align: center;
    }
    .BigIcon {
        display: inline-block;
        width: 70px;
        height: 70px;
        overflow: hidden;
    }
    /* .BigIcon img {
        width: 100%;
        border-radius: 5px;
    } */
</style>

<div class="BigIcon" style={colorVar}>
    <!-- {#if image}
        <img src={image} alt="avatar" />
    {:else} -->
        <div class="icon">
            <i class={icon}></i>
        </div>
    <!-- {/if} -->
</div>